export default (state) => {
  state.currentAdministrator.fundersReport.isFetching = false;
};
